import Vue from "@/libraries/vue";
import { timeout } from "@/assets/js/utils";
import postsStore from "@/store/posts";
export default Vue.extend({
    name: "LayoutDefault",
    data() {
        return {
            dialog: false,
            page: "",
        };
    },
    computed: {
        posts: () => postsStore.posts,
        xs() {
            const vuetify = this.$vuetify;
            return !!vuetify && !!vuetify.breakpoint.xs;
        },
        nav() {
            return [
                { text: "fuentes", link: "/fuentes" },
                { text: "explicaciones", link: "/explicaciones" },
                { text: "tags", link: "/tags" },
            ];
        },
        names() {
            const posts = this.posts;
            const name = [];
            for (const group in posts) {
                for (const post of posts[group]) {
                    if (!post.id)
                        continue;
                    name.push({
                        text: post.name,
                        value: postsStore.postLink(post, group),
                    });
                }
            }
            return [...new Set(name)];
        },
    },
    watch: {
        async page(page) {
            if (page) {
                await timeout(1);
                this.$refs.search.blur();
                this.page = "";
                this.$router.push(page);
            }
        },
    },
});
